export default "__VITE_ASSET__674a0aa8__"